<script setup lang="ts">
const props = defineProps<{
  blockedCalendar: boolean
  bookingSent: boolean
  calendarError?: string
  onlineReservation: boolean
  periodBookableOnline: boolean
  showTotalPrice: boolean
}>()
const emits = defineEmits<{
  'submit-date-picker': [$event: MouseEvent, preBooking: boolean]
}>()
const { isTreatment } = useExperiment('38576-house-question-v4')
const showReinsuranceMessage = computed(
  () => props.showTotalPrice && !props.onlineReservation,
)
const showBookingBtn = computed(
  () =>
    props.onlineReservation &&
    (!isTreatment.value || props.periodBookableOnline),
)
const disableSubmit = computed(() =>
  Boolean(props.blockedCalendar || props.calendarError),
)

const submitDatePicker = ($event: MouseEvent, preBooking = false) => {
  emits('submit-date-picker', $event, preBooking)
}
</script>

<template>
  <div class="flex flex-col">
    <div
      v-if="bookingSent"
      class="flex w-full items-center justify-center gap-1 rounded bg-secondary-100 py-2 text-sm text-secondary-200"
    >
      <p class="m-0 font-bold">{{ $t('preOrder.bookingSent') }}</p>
      <BaseIcon name="check" />
    </div>

    <div v-else class="-mx-1.5 -mb-3 flex flex-wrap items-center">
      <BaseButton
        v-if="!isTreatment || !periodBookableOnline || !onlineReservation"
        class="mx-1.5 mb-3 w-1/2 flex-1 whitespace-nowrap !px-4"
        color="secondary"
        :variant="showBookingBtn ? 'outline' : 'btn'"
        data-cy="inquiry-date-picker__inquiry-btn"
        :disabled="disableSubmit"
        @click="submitDatePicker"
      >
        {{ $t('house.request') }}
      </BaseButton>

      <BaseButton
        v-if="showBookingBtn"
        class="mx-1.5 mb-3 w-1/2 flex-1 whitespace-nowrap !px-4"
        color="secondary"
        :disabled="disableSubmit || !periodBookableOnline"
        @click="submitDatePicker($event, true)"
      >
        {{ $t('preOrder.cta') }}
      </BaseButton>
    </div>

    <p
      v-if="calendarError || !periodBookableOnline"
      class="order-1 mb-0 mt-2 text-center text-sm text-error"
    >
      {{ calendarError || $t('house.preOrder.errorDate') }}
    </p>
    <p
      v-else-if="showReinsuranceMessage"
      class="mb-0 mt-2 text-center text-xs text-gray-500"
    >
      {{ $t('inquiry.sendingRequest') }}
    </p>
  </div>
</template>
